/**
 * @file: 号码认证二级模块
 * @author: wence
 */
import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classnames from 'classnames';

import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import SearchBar from '../../components/searchBar';
import {getNumberCommonList} from '../../actions/numberAuthAction';

class NumberAuth extends PureComponent {
    static propTypes = {
        bannerInfo: PropType.object,
        numberCommonList: PropType.array,
        getNumberCommonList: PropType.func,
    };

    componentDidMount() {
        // this.props.getNumberCommonList();
    }

    render() {
        const {numberCommonList} = this.props;
        const bannerInfo = this.props.bannerInfo || {};

        return (
            <div className="product">
                <div className="pro-banner-box bg-new">
                    <div className="proBanner">
                        <ProBanner
                            title={bannerInfo.title}
                            urlText={bannerInfo.urlText}
                            bgImg={bannerInfo.bgImg}
                            url={bannerInfo.url}
                        />
                    </div>
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>
                <div className={'product-des'}>
                    {bannerInfo.bannerNote}
                    <br/>
                    <br/>
                    关于号码标记，申诉及问题解答，您可添加QQ群 <span style={{color: '#38F'}}>119723959</span> 联系群内工作人员
                </div>
                <div className="product-mod">
                    <ProductTitle title="业务受理"/>
                </div>
                <div className="product-mod">
                    <a href="https://haoma.baidu.com/attest" className="number-auth-product-item">
                        <div className="number-auth-product-item-icon">
                            <img src={require('../../asset/svg/icon_qiyehaomarenzheng.svg')} alt="icon"/>
                        </div>
                        <div className="number-auth-product-item-title">
                            <span>企业号码认证</span>
                            <span>通话时显示企业专属电话名牌</span>
                        </div>
                        <img src={require('../../asset/svg/icon_arrow_wap.svg')} alt="icon"/>
                    </a>
                    <a href="https://haoma.baidu.com/appeal" className="number-auth-product-item">
                        <div className="number-auth-product-item-icon">
                            <img src={require('../../asset/svg/icon_qiyehaomashensu.svg')} alt="icon"/>
                        </div>
                        <div className="number-auth-product-item-title">
                            <span>企业号码申诉</span>
                            <span>企业号码信息显示错误可申诉修正</span>
                        </div>
                        <img src={require('../../asset/svg/icon_arrow_wap.svg')} alt="icon"/>
                    </a>
                    <a href="https://haoma.baidu.com/appeal" className="number-auth-product-item">
                        <div className="number-auth-product-item-icon">
                            <img src={require('../../asset/svg/icon_gerenhaomashensu.svg')} alt="icon"/>
                        </div>
                        <div className="number-auth-product-item-title">
                            <span>个人号码申诉</span>
                            <span>个人号码信息显示错误可申诉修正</span>
                        </div>
                        <img src={require('../../asset/svg/icon_arrow_wap.svg')} alt="icon"/>
                    </a>
                    <a href="https://haoma.baidu.com/mark" className="number-auth-product-item">
                        <div className="number-auth-product-item-icon">
                            <img src={require('../../asset/svg/icon_saoraodianhuajubao.svg')} alt="icon"/>
                        </div>
                        <div className="number-auth-product-item-title">
                            <span>骚扰电话举报</span>
                            <span>骚扰电话不胜其烦可快速举报</span>
                        </div>
                        <img src={require('../../asset/svg/icon_arrow_wap.svg')} alt="icon"/>
                    </a>
                </div>

                <div className="product-mod" style={{display: 'none'}}>
                    <ProductTitle title="常用号码"/>
                </div>
                <div className="product-mod" style={{display: 'none'}}>
                    <a href="/m/haoma/search">
                        <SearchBar disabled placeholder="请输入要查询的电话号码或关键字"/>
                    </a>
                    <div className="number-auth-hotline">
                        {!!numberCommonList
                        && numberCommonList.length > 0
                        && numberCommonList.map((item, index) => {
                            return (
                                <a
                                    href={'/m/haoma/common/' + item.id}
                                    key={item.id}
                                    className={classnames(
                                        'number-auth-hotline-item',
                                        {no: (index + 1) % 4 === 0 && index !== 0})}>
                                    <div className="img">
                                        <img src={item.iconurl} alt={item.name}/>
                                    </div>
                                    {item.name}
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    state => ({numberCommonList: state.numberCommonList}),
    dispatch => bindActionCreators({getNumberCommonList}, dispatch)
)(NumberAuth));



// WEBPACK FOOTER //
// ./src/containers/product/numberAuth.js